// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-control/MissionControlMetric.jsx

import React from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function MissionControlMetric({
  label,
  value,
  supportingText,
  tone = "neutral",
  onClick,
  title,
}) {
  const Component = onClick ? "button" : "div";

  return (
    <Component
      type={onClick ? "button" : undefined}
      onClick={onClick}
      title={title}
      className={joinClassNames(
        "mission-control-metric",
        `mission-control-metric--${tone}`,
        onClick && "mission-control-metric--interactive"
      )}
    >
      <span className="mission-control-metric__label">{label}</span>
      <strong className="mission-control-metric__value">{value}</strong>
      {supportingText ? (
        <span className="mission-control-metric__supporting">
          {supportingText}
        </span>
      ) : null}
    </Component>
  );
}
